// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"4983ec9f","179":"0f11c1dd","213":"0c8f1caa","219":"a11411ed","367":"1c7ff6ab","445":"aa908822","453":"d1fa110c","547":"aa559919","624":"88adf5da","676":"bb65d8ec","732":"74d40df9","824":"6c721a7a","955":"9fc1950d"}[chunkId] + ".chunk.js";
};